import PropTypes from 'prop-types';

import { CBox } from './CBox'

import Typography from '@mui/joy/Typography'

import { PulseLoader } from 'react-spinners';

export function LoadingPage({
  loadingText
}) {
  return (
    <CBox sx={{ width: '100%', aspectRatio: '16/9' }}><PulseLoader /><Typography>{loadingText}</Typography></CBox>
  )
}

LoadingPage.propTypes = {
  loadingText: PropTypes.string
}

export default LoadingPage;
